import React, { useEffect, useState } from "react";
import Encounter from '../../../../globalcomponents/patient360/medicalhistory/encounter'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
const PatientEncounter = (props) => {
  return (
    <>
      <Encounter data={props.formValues.patientdata} app="Site" />
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    formValues: state.form,
    state
  }
}

export default withRouter(connect(mapStateToProps, null)(PatientEncounter));



